import { useState } from "react";
import { Form, FormGroup, Input, Label } from "reactstrap"

export default function SearchInFilters({ onChangeCallback }) {
    const [value, setValue] = useState('');
    
    const handleChangeSearch = (e) => {
        const inputValue = e.target.value;
        setValue(inputValue);

        onChangeCallback && onChangeCallback(inputValue);
    }

  return (
    <Form>
        <FormGroup floating>
            <Input 
                bsSize="sm"
                type="text" 
                name="search" 
                value={value}
                className={` form-control`} 
                placeholder="Search"
                onChange={(e) => handleChangeSearch(e)}
            />
            <Label>
                Search
            </Label>
        </FormGroup>
    </Form>
  )
}
